import { msg } from "@lingui/core/macro";
import { useNavigate } from "@tanstack/solid-router";
import { useI18n } from "@/providers/i18n-provider";
import { NotFoundState } from "@/components/ui/not-found-state";

/**
 * Router's global `defaultNotFoundComponent`: any unknown URL shows
 * this state instead of a blank screen. It renders inside the root's
 * `<Outlet>` (with all providers available).
 */
export function NotFoundRoute() {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <div class="flex min-h-dvh flex-1 items-center justify-center bg-background p-6">
      <NotFoundState
        emoji="🔒"
        title={t(msg`We can't find that`)}
        description={t(msg`The page you're looking for isn't here. Let's go back home!`)}
        primaryAction={{
          label: t(msg`Go home`),
          onClick: () => {
            void navigate({ to: "/" });
          },
        }}
      />
    </div>
  );
}
